<template>
    <div>
        <default-navigation navbarClass="bg-primary"></default-navigation>
        <section class="bg-primary pt-0">
            <div class="custom-container">
                <div class="row justify-content-center">
                    <div class="col-xl-8 text-center">
                        <h1>Een onderzoek versturen</h1>
                        <p>Beste {{ user.name }},</p>
                        <p class="mb-4">
                            Er staan op dit e-mailadres ({{ user.email }}) {{ inquiries.length }} onderzoeken geregistreerd, waarvan {{ unsentInquiriesCount }} nog niet verstuurd.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="custom-container">
                <div class="row justify-content-center">
                    <div class="col-xl-8 text-center">
                        <div class="alert alert-warning d-flex mb-2" role="alert">
                            <i class="fi fi-rr-info me-2"></i>
                            <span class="text-start">
                                Toch nog mensen toevoegen aan een onderzoek? Klik hieronder op de <strong class="bold">afdeling</strong> van het onderzoek om mensen toe te voegen. <br>
                                <strong class="bold">Let op:</strong> Dit kan alleen als de uiterste inleverdatum nog niet verstreken is!
                            </span>
                        </div>
                        <div class="alert alert-danger" role="alert" v-if="error !== null">
                            {{ error }}
                        </div>
                        <table class="table text-start">
                            <thead class="table-primary pt-4 pb-4">
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Afdeling</th>
                                <th scope="col">Aantal uitgenodigd</th>
                                <th scope="col">Uiterste inleverdatum</th>
                                <th scope="col">Aangemaakt op</th>
                                <th scope="col">Actie</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, key) in inquiries" :key="key">
                                <th scope="row">{{ key + 1 }}</th>
                                <td>
                                    <router-link :to="'/onderzoeken/' + user.hash + '/aanpassen/' + item.id" class="btn btn-sm btn-grey" data-bs-toggle="tooltip" data-bs-placement="top"
                                                 title="Genodigden bekijken / toevoegen" v-if="item.isExpired === false">
                                        {{ item.department }} <i class="fi fi-rr-edit"></i>
                                    </router-link>
                                    <span v-else class="btn btn-sm btn-no-button">{{ item.department }}</span>
                                </td>
                                <td>{{ item.amountRecipients }}</td>
                                <td>{{ formatDate(item.deadline) }}</td>
                                <td>{{ formatDate(item.createdAt) }}</td>
                                <td>
                                    <div>
                                        <button class="btn btn-sm btn-primary mb-0" :disabled="loading[key]" v-if="item.sent === null" @click="sendInquiry($event, item, key)">
                                            <span v-if="loading[key]"><i class="fas fa-circle-notch fa-spin"></i></span>
                                            <span v-else>Verstuur</span>
                                        </button>
                                        <router-link class="btn btn-sm btn-secondary" :to="'/onderzoeken/' + user.hash + '/resultaten?select=' + item.id" v-if="item.sent !== null">
                                            Resultaten
                                        </router-link>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import {DateTime} from 'luxon';
import {Tooltip} from 'bootstrap';
import InquiryService from "../../../services/InquiryService";
import Swal from 'sweetalert2';

export default {
    name: 'Inquiries',
    data() {
        return {
            user:                 {
                name:  null,
                email: null
            },
            inquiries:            [],
            sentInquiriesCount:   0,
            unsentInquiriesCount: 0,
            error:                null,
            loading:              []
        }
    },
    watch: {
        inquiries: function(inquiries) {
            this.sentInquiriesCount   = inquiries.reduce((acc, val) => (val.sent !== null) ? acc + 1 : acc, 0);
            this.unsentInquiriesCount = inquiries.reduce((acc, val) => (val.sent === null) ? acc + 1 : acc, 0);

            this.createTooltips();
        }
    },
    beforeRouteEnter(to, from, next) {

        InquiryService.getInquiries(to.params.token).then(({ user, inquiries }) => {
            if(!user) {
                throw 'User not found';
            }

            next((vm) => {
                vm.user      = user;
                vm.inquiries = inquiries;
            });
        }).catch((error) => {
            next({ path: '/' });
        });
    },
    methods: {
        formatDate(date) {
            return DateTime.fromJSDate(new Date(date)).setLocale('nl').toFormat('dd LLL yyyy');
        },
        inThePast(date) {
            return DateTime.fromJSDate(new Date(date)).setLocale('nl').diff(
                DateTime.now().endOf('day').setLocale('nl'),
                'hours'
            ).values.hours < 0;
        },
        sendInquiry(event, inquiry, key) {
            event.preventDefault();
            this.error = null;
            this.$set(this.loading, key, true);

            const vm = this;

            InquiryService.sendInquiry(this.user.hash, inquiry.id).then(({ inquiry }) => {
                if(inquiry) {
                    vm.$set(vm.inquiries, key, inquiry);
                    this.loading.splice(key, 1);
                }
            }).catch((error) => {
                this.loading.splice(key, 1);
                this.error = 'Er is iets niet goed gegaan, probeer het opnieuw';
            });
        },
        createTooltips() {
            setTimeout(() => {
                const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]');

                tooltipTriggerList.forEach((tooltipTriggerEl) => {
                    if(!Tooltip.getInstance(tooltipTriggerEl)) {
                        return new Tooltip(tooltipTriggerEl)
                    }
                });
            }, 500);
        }
    },
    mounted() {
        if(this.$route.query.opgeslagen && this.$route.query.opgeslagen === 'success') {
            Swal.fire('Opgeslagen', 'Het onderzoek is succesvol opgeslagen!', 'success');

            this.$router.replace({ 'query': null });
        }
    }
}
</script>
